import { useUserSession } from '@phx-husky/use-user-session';
import { navigate } from 'gatsby';
import React, { FC } from 'react';

import { AuthShowProps } from './models';

// eslint-disable-next-line complexity
const AuthShow: FC<AuthShowProps> = ({
  children,
  forSignedIn,
  forSignedOut,
  redirectOnFail,
}) => {
  const { isSignedIn, userLoading } = useUserSession();

  if (userLoading === 'loading') {
    return null;
  }

  const showContent =
    (isSignedIn() && forSignedIn) || (!isSignedIn() && forSignedOut);

  if (
    userLoading === 'success' &&
    !showContent &&
    redirectOnFail &&
    typeof window !== 'undefined'
  ) {
    navigate(redirectOnFail);

    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{showContent ? children : null}</>;
};

export default AuthShow;
